const locale = {
    placeholder: 'Hora',
    rangePlaceholder: ['Hora de início', 'Hora de fim'],
};
export default locale;
